import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import { TwcProduct } from '../../../twc-products';

export const LIGHTNING_PRODUCT_DATA: TwcProduct = {
  defaultProductId: '403',
  description: 'TWC product (vector) - Global Lightning',
  flightLevelProductIds: {},
  forecastTimeSlicePeriod: 0,
  id: 'lightning',
  label: 'Lightning',
  lodMax: 0,
  productName: 'Weather-Lightning-TWC',
  protocol: 'VectorTile',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  weatherType: 'LIGHTNING',
  zOrder: 85,
  layerSpecs: {
    geoJSON: {
      geometryType: 'point',
      declutter: false,
      renderer: new SimpleRenderer({
        symbol: {
          type: 'picture-marker',
          url: `assets/weather/sprites/lightning@3x_60x90.png`,
          width: '40px',
          height: '60px'
        } as any,
        visualVariables: [
          {
            type: 'size',
            field: 'signedPeakAmplitude',
            stops: [
              { value: 20, size: 8 },
              { value: 100, size: 32 }
            ]
          } as any
        ]
      }),
      definitionExpression: 'signedPeakAmplitude >= 12'
    }
  }
};
